module.exports={render:function (){with(this) {
  return _h('section', {
    staticClass: "ion-buttons",
    class: [cTheme]
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a6ab882!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/src/buttons.vue
// module id = 161
// module chunks = 0